import React from "react";
import { fmtEur } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Trophy, Layers, Package } from "lucide-react";

function Diff({ nostro, loro }) {
  if (!loro || !nostro) return null;
  const d = ((nostro - loro) / loro) * 100;
  return <span className={`text-xs font-semibold ${d > 0 ? "text-rose-600" : "text-emerald-700"}`}>{d > 0 ? "+" : ""}{d.toFixed(1)}% vs concorrente</span>;
}

function Card({ title, icon: Icon, totale, loro, best, children, onCreate, testId, color }) {
  return (
    <div className={`bg-white border-2 rounded-lg p-4 flex flex-col ${best ? "border-emerald-500 shadow-md" : "border-zinc-200"}`} data-testid={testId}>
      <div className="flex items-center justify-between mb-1">
        <div className="font-bold flex items-center gap-1.5" style={{ color }}><Icon className="h-4 w-4" />{title}</div>
        {best && <span className="text-[10px] bg-emerald-100 text-emerald-800 px-1.5 py-0.5 rounded-sm inline-flex items-center gap-1"><Trophy className="h-3 w-3" />più vicino</span>}
      </div>
      <div className="text-2xl font-extrabold font-mono" data-testid={`${testId}-totale`}>{fmtEur(totale)}</div>
      <Diff nostro={totale} loro={loro} />
      <div className="text-[11px] text-zinc-500 mt-2 flex-1">{children}</div>
      <Button onClick={onCreate} className="mt-3 w-full" variant={best ? "default" : "outline"} data-testid={`${testId}-crea`}>Crea questo preventivo</Button>
    </div>
  );
}

export default function Confronto({ calc, totaleConcorrente, onCreateComposite, onCreatePacchetto }) {
  if (!calc) return null;
  const vpv = calc.voce_per_voce;
  const all = [{ k: "vpv", t: vpv.totale }, ...calc.pacchetti.map((p) => ({ k: p.package_id, t: p.totale }))];
  const target = totaleConcorrente || 0;
  const bestKey = target ? all.reduce((a, b) => (Math.abs(b.t - target) < Math.abs(a.t - target) ? b : a)).k : null;
  return (
    <div data-testid="imp-confronto">
      <div className="flex items-end justify-between mb-3 flex-wrap gap-2">
        <div>
          <div className="text-xs uppercase tracking-wider text-zinc-500">Confronto (IVA esclusa)</div>
          <div className="text-sm">Concorrente: <strong className="font-mono" data-testid="imp-totale-concorrente">{fmtEur(target)}</strong></div>
        </div>
        {calc.maggiorazione_mq > 1 && <div className="text-[11px] text-amber-700">Sotto i 60 mq si applica la maggiorazione ×{calc.maggiorazione_mq}</div>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-3">
        <Card title="Voce per voce" icon={Layers} totale={vpv.totale} loro={target} best={bestKey === "vpv"} testId="imp-card-vpv" color="#7C3AED" onCreate={onCreateComposite}>
          Voci: {fmtEur(vpv.subtotale)} + sicurezza {vpv.sicurezza_pct}% + direzione lavori {vpv.direzione_pct}%.
          {vpv.senza_prezzo > 0 && <div className="text-amber-700 mt-1">{vpv.senza_prezzo} righe senza prezzo</div>}
        </Card>
        {calc.pacchetti.map((p) => (
          <Card key={p.package_id} title={p.name} icon={Package} totale={p.totale} loro={target} best={bestKey === p.package_id} testId={`imp-card-${p.package_id}`} color={p.color} onCreate={() => onCreatePacchetto(p)}>
            Pacchetto {fmtEur(p.base)} + extra {fmtEur(p.extras_totale)}
            <div>{p.coperte.length} voci coperte dal pacchetto · {p.extras.length} extra</div>
            {p.coperte.length > 0 && <div className="mt-1 text-zinc-400 line-clamp-3" title={p.coperte.map((c) => c.name).join(", ")}>Incluse: {p.coperte.map((c) => c.name).join(", ")}</div>}
            {p.n_voci_pacchetto === 0 && <div className="mt-1 text-amber-700">Pacchetto senza voci configurate: tutto risulta extra</div>}
          </Card>
        ))}
      </div>
    </div>
  );
}
